import React from 'react';

import * as types from './types';

export default (state, action) => {
  switch (action.type) {
    case types.SET_DATA_ON_INTERVIEW_OUTCOME:
      return { ...state, ...action.payload, isDataUpdating: false };
    case types.UPDATE_DATA_ON_COVER_CHANGE:
      return { ...state, ...action.payload, isDataUpdating: false };
    case types.SET_IS_UPDATING: {
      return { ...state, isDataUpdating: true };
    }
    default:
      return { ...state };
  }
};
